export default __webpack_public_path__ + "static/media/Foto19.eb940164.png";